import { Link } from 'react-router-dom';
import { Card, Badge, Button, terminologyOf } from '@getpay93/ui';
import { useClientView } from '../../data/hooks';
import { useAuth } from '../../auth/AuthContext';
import { money, shortDate } from '../../lib/format';

export function Inicio() {
  const view = useClientView();
  const { session } = useAuth();
  const term = terminologyOf(session?.org?.type);
  const v = view.data;
  const pending = (v?.invoices ?? []).find((i) => i.status === 'pending');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <Card>
        <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.08em', color: 'var(--text-hint)' }}>Tu membresía como {term.customer}</div>
        <h2 style={{ margin: '4px 0', fontSize: 20, fontWeight: 800, color: 'var(--text-strong)' }}>{v?.orgName ?? '…'}</h2>
        {v?.activePlan ? (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontWeight: 700, color: 'var(--text-body)' }}>{v.activePlan.planName}</span>
              <Badge tone={v.activePlan.status === 'active' ? 'paid' : v.activePlan.status === 'paused' ? 'pending' : 'neutral'}>{v.activePlan.status}</Badge>
            </div>
            <div style={{ fontSize: 26, fontWeight: 800, color: 'var(--brand-green)', margin: '6px 0' }}>{money(v.activePlan.price)}</div>
            <div style={{ fontSize: 13, color: 'var(--text-hint)' }}>
              {v.activePlan.status === 'paused' && v.activePlan.pausedUntil ? `Pausado hasta ${shortDate(v.activePlan.pausedUntil)}` : `Próximo cobro: ${shortDate(v.activePlan.nextBillingDate)}`}
            </div>
          </div>
        ) : (
          <p style={{ color: 'var(--text-hint)' }}>Sin plan activo.</p>
        )}
      </Card>

      {pending ? (
        <Card padding={16} style={{ borderColor: 'var(--status-pending)' }}>
          <div style={{ fontWeight: 700, color: 'var(--text-strong)' }}>Pago pendiente</div>
          <div style={{ fontSize: 22, fontWeight: 800, color: 'var(--status-pending)', margin: '4px 0' }}>{money(pending.amount)}</div>
          <div style={{ fontSize: 13, color: 'var(--text-hint)', marginBottom: 12 }}>Vence {shortDate(pending.dueDate)}</div>
          <Link to="/app/pagos"><Button fullWidth>Subir comprobante</Button></Link>
        </Card>
      ) : (
        <Card><p style={{ margin: 0, color: 'var(--text-hint)' }}>Estás al día. Sin pagos pendientes.</p></Card>
      )}
    </div>
  );
}
